import _classCallCheck from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/samlee/Documents/GitHub/samanthallee.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import { deepExtend } from "../../../../Utils/Utils";
var charKey = "character",
    charAltKey = "char",
    imageKey = "image",
    imageAltKey = "images",
    polygonKey = "polygon",
    polygonAltKey = "star";
export var Shape = /*#__PURE__*/function () {
  function Shape() {
    _classCallCheck(this, Shape);

    this.options = {};
    this.type = "circle";
  }

  _createClass(Shape, [{
    key: "character",
    get: function get() {
      var _a;

      return (_a = this.options[charKey]) !== null && _a !== void 0 ? _a : this.options[charAltKey];
    },
    set: function set(value) {
      this.options[charAltKey] = this.options[charKey] = value;
    }
  }, {
    key: "custom",
    get: function get() {
      return this.options;
    },
    set: function set(value) {
      this.options = value;
    }
  }, {
    key: "image",
    get: function get() {
      var _a;

      return (_a = this.options[imageKey]) !== null && _a !== void 0 ? _a : this.options[imageAltKey];
    },
    set: function set(value) {
      this.options[imageAltKey] = this.options[imageKey] = value;
    }
  }, {
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }, {
    key: "polygon",
    get: function get() {
      var _a;

      return (_a = this.options[polygonKey]) !== null && _a !== void 0 ? _a : this.options[polygonAltKey];
    },
    set: function set(value) {
      this.options[polygonAltKey] = this.options[polygonKey] = value;
    }
  }, {
    key: "stroke",
    get: function get() {
      return [];
    },
    set: function set(_value) {}
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (!data) {
        return;
      }

      var options = (_a = data.options) !== null && _a !== void 0 ? _a : data.custom;

      if (options !== undefined) {
        for (var shape in options) {
          var item = options[shape];

          if (item) {
            this.options[shape] = deepExtend((_b = this.options[shape]) !== null && _b !== void 0 ? _b : {}, item);
          }
        }
      }

      this.loadShape(data.character, charKey, charAltKey, true);
      this.loadShape(data.polygon, polygonKey, polygonAltKey, false);
      this.loadShape((_c = data.image) !== null && _c !== void 0 ? _c : data.images, imageKey, imageAltKey, true);

      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(item, mainKey, altKey, altOverride) {
      var _a, _b;

      if (!item) {
        return;
      }

      var isArray = item instanceof Array;
      var emptyValue = isArray ? [] : {},
          mainDifferentValues = isArray !== this.options[mainKey] instanceof Array,
          altDifferentValues = isArray !== this.options[altKey] instanceof Array;

      if (mainDifferentValues) {
        this.options[mainKey] = emptyValue;
      }

      if (altDifferentValues && altOverride) {
        this.options[altKey] = emptyValue;
      }

      this.options[mainKey] = deepExtend((_a = this.options[mainKey]) !== null && _a !== void 0 ? _a : emptyValue, item);

      if (!this.options[altKey] || altOverride) {
        this.options[altKey] = deepExtend((_b = this.options[altKey]) !== null && _b !== void 0 ? _b : emptyValue, item);
      }
    }
  }]);

  return Shape;
}();